import type { TourDefinition } from '../../types/tour';

export const sessionDetailFirstTour: TourDefinition = {
  key: 'session_detail_first',
  title: '会議履歴詳細ツアー',
  steps: [
    {
      target: '#session-summary',
      title: 'サマリー',
      content:
        '会議全体の要約がここに自動生成されます。クリックで全文展開できます。',
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '#session-action-items',
      title: 'アクションアイテム',
      content:
        '抽出されたアクションアイテムの一覧です。完了マークをつけたり、CRM に連携できます。',
      placement: 'top',
    },
    {
      target: '#session-replay',
      title: '再生',
      content:
        'タイムスタンプ付きで会議の文字起こしを再生できます。重要な瞬間に飛ぶこともできます。',
      placement: 'left',
    },
  ],
};
